import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { callOpenWorkOrderForEnergySaleJet } from '../../../utilities/openWorkOrder';
import {
  createOtp,
  getDetails,
  getOderPrice,
  getEMVStep1,
  getEMVStep2,
  createWorkOrder,
  // checkWhatsAppActivity,
  createEnergySignatureFile,
  getEnergySignatureFileStatus
} from './energySaleBlockAsyncThunk';
import { energySalePages } from './energySalePages';

const Steps1 = {
  CHECK_METER : 'בדיקת מונה',
  CHOOSE_PACKAGE  : 'בחירת מסלול',
  JOIN : 'הצטרפות'
}

const Steps2 = {
  CHOOSE_PACKAGE  : 'בחירת מסלול',
  CHECK_METER : 'בדיקת מונה',
  JOIN : 'הצטרפות'
}

const initialState = {
  energySaleBlockData: {
    blockId: 0,
    packages: [],
    isWhatsAppActive: false,
    whatsAppServiceNumber: '',
    smartMeterPrice: '',
    formCodeSmartMeter: '',
    formCodeNotSmartMeter: '',
    epiText:{}
  },
  iframeUrl:'',
  saleType: 'energy',
  orderType: 'provide',
  saleCatalog: {},
  page: 'otpFormPage',
  startPosition: '',
  isStartWithSelectedPackage: false,
  pageSettings: {step:1},
  progressBarPoints: [],
  otpDetails: {
    phoneNumber: '',
    identityNumber: '',
    numOfAttempts: 0,
    verifyCode: '',
    valid: '',
    error: '',
  },
  iecResponse: {},
  sessionId: null,
  isSubmit: false,
  displayAlternativePackage: false,
  isDisplayPopupForHelp: false,
  serviceMessageType: '',
  errorPage: { errorType:'GENERAL_ERROR', description: '' },
  errorText: '',
  personalInfo: { firstName: '', lastName: '', email: '' ,  isReceivingAd: false },
  confirmTerms: {value: false, error: ''},
  signatureInfo: {isSigned :  false},
  userAddress: {},
  selectedPackage: {},
  paymentInfo: { iframeUrl: '', numberOfPayments: '' },
  summaryDetails: {orderId : ''},
  stepsList: null,
  workOrderSuccess: false,
};

const energySaleBlockSlice = createSlice({
  name: 'energySaleBlock',
  initialState: initialState,
  reducers: {
    resetBlock: (state) => initialState,
    initEnergySale: {
      reducer: (state, action) => {
        state.energySaleBlockData = action.payload.energySaleBlockData;
        state.page = action.payload.page;
        state.progressBarPoints = action.payload.progressBarPoints;
        state.selectedPackage = action.payload.selectedPackage;
        state.startPosition = action.payload.startPosition;
        state.isStartWithSelectedPackage = action.payload.isStartWithSelectedPackage;
        state.pageSettings = action.payload.pageSettings;
        state.stepsList = action.payload.stepsList;
      },
      prepare: (action) => {
        let payload = {};
        const energySaleBlock = action.energySaleBlock;



        const epiText = {
          otpFormPage: {
            title : energySaleBlock.titleOtpFormPage?.value,
            subTitle : energySaleBlock.subTitleOtpFormPage?.value,
            titleStartFromPackage : energySaleBlock.titleOtpFormPageStartFromPackage?.value,
            subTitleStartFromPackage : energySaleBlock.subTitleOtpFormPageStartFromPackage?.value,
            remark : energySaleBlock.remarkOtpFormPage?.value,
          },
          serviceMessagePage:{
            titleYesSmartMone : energySaleBlock.titleYesSmartMone?.value,
            titleNoSmartMone : energySaleBlock.titleNoSmartMone?.value,
          },
          loadingPage: {
            title : energySaleBlock.titleLoadingPage?.value,
            subTitle : energySaleBlock.subTitleLoadingPage?.value,
            remark : energySaleBlock.remarkLoadingPage?.value,
          },
          packagesPage: {
            title : energySaleBlock.titlePackagePage?.value,
            subTitle : energySaleBlock.subTitlePackagePage?.value,
            titleAlternativeNotSmartMeter : energySaleBlock.titleAlternativeNotSmartMeterPackagePage?.value,
            subTitleAlternativeNotSmartMeter : energySaleBlock.subTitleAlternativeNotSmartMeterPackagePage?.value,
          },
          digitalSignaturePage:{
            title : energySaleBlock.titleDigitalSignaturePage?.value,
            subTitleYesSmartMone : energySaleBlock.subTitleYesSmartMoneDigitalSignaturePage?.value,
            subTitleNoSmartMone : energySaleBlock.subTitleNoSmartMoneDigitalSignaturePage?.value,
          },
          successPage:{
            title : energySaleBlock.titleSuccessPage?.value,
            timeText : energySaleBlock.timeTextSuccessPage?.value,
          }
        }

        const energySaleBlockData = {
          blockId: energySaleBlock.contentLink.id,
          packages: energySaleBlock.energySalePackages,
          isWhatsAppActive: !!energySaleBlock.isWhatsAppActive?.value,
          whatsAppServiceNumber: energySaleBlock.whatsAppServiceNumber?.value,
          smartMeterPrice: energySaleBlock.smartMeterPrice?.value,
          formCodeSmartMeter: energySaleBlock.formCodeSmartMeter?.value,
          formCodeNotSmartMeter: energySaleBlock.formCodeNotSmartMeter?.value,
          epiText: epiText
        };

        const salePackage = action.salePackage;
        const selectedPackage = getSelectedPackage(salePackage);
        const hasSelectedPackage = salePackage && Object.keys(salePackage).length > 0;
        const startPosition = hasSelectedPackage ? 'startWithPackage' : 'startWithoutPackage';

        const stepsList = hasSelectedPackage ? Object.values(Steps2) : Object.values(Steps1);

        const page = 'otpFormPage';
        // const page = 'PersonalInfoPage';

        payload.energySaleBlockData = energySaleBlockData;
        payload.page = page;
        payload.selectedPackage = selectedPackage;
        payload.startPosition = startPosition;
        payload.isStartWithSelectedPackage = hasSelectedPackage;
        payload.pageSettings = getPageSettings(startPosition, page);
        payload.stepsList = stepsList;
        return { payload: payload };
      },
    },
    setIsSubmit: (state, action) => {
      state.isSubmit = action.payload;
    },
    goToPage: (state, action) => {
      state.pageSettings = getPageSettings(state.startPosition, action.payload);
      state.page = action.payload;
      window.scrollTo(0, 0);
    },
    saveToHistory: (state, action) => {},
    reportAnalytics: (state, action) => { },
    reportDWH: (state, action) => { },
    setErrorPage: (state, action) => {
      state.errorPage.description = action.payload.description;
      state.errorPage.errorType = action.payload.errorType;
      if (action.payload.isOpenWorkOrder) {
        callOpenWorkOrderForEnergySaleJet(state);
      }
      state.page = 'errorPage';
      state.pageSettings = getPageSettings(state.startPosition, 'errorPage');
    },
    setErrorText: (state, action) => {
      state.errorText = action.payload;
     },
    setOtpForm: (state, action) => {
      state.otpDetails.phoneNumber = action.payload.phoneNumber;
      state.otpDetails.identityNumber = action.payload.identityNumber;
    },
    setOtpCode:(state, action) => {
      state.otpDetails.verifyCode = action.payload;
    },
    setOtpErrorMsg: (state, action) => {
      state.otpDetails.error = action.payload;
    },
    setPersonalInfo: (state, action) => {
      state.personalInfo.firstName = action.payload.firstName ? action.payload.firstName : state.personalInfo.firstName;
      state.personalInfo.lastName = action.payload.lastName ? action.payload.lastName : state.personalInfo.lastName;
    },
    setUserAddress: (state, action) => {
      state.userAddress = action.payload;
    },
    setConfirmTerms: (state, action) => {
      state.confirmTerms.value = action.payload;
    },
    setConfirmTermsError: (state, action) => {
      state.confirmTerms.error = action.payload;
    },
    setSelectedPackage: (state, action) => {
      state.selectedPackage = getSelectedPackage(action.payload);
    },
    setSelectedUserAddress: (state, action) => {
      state.userAddressPage.selectedAddress = action.payload.address;
    },
    setEmail: (state, action) => {
      state.personalInfo.email = action.payload;
    },
    setIsReceivingAd: (state, action) => {
      state.personalInfo.isReceivingAd = action.payload;
    },
    resetCgIframeUrl: (state, action) => {
      state.paymentInfo.iframeUrl = null;
    },
    setServiceMessageType:(state, action) => {
      state.serviceMessageType = action.payload;
    },
    setIsWhatsAppActive:(state, action) => {
      state.isWhatsAppActive = action.payload;
    },
    setIsDisplayPopupForHelp:(state, action) => {
      state.isDisplayPopupForHelp = action.payload;
      if(!action.payload){
        state.workOrderSuccess = false;
      }
    },
    setDisplayAlternativePackage: (state, action) => {
      state.displayAlternativePackage = action.payload;
    },
    setIecResponse  : (state, action) => {
      state.iecResponse = action.payload;
    },
    setIframeUrl : (state, action) => {
      state.iframeUrl = action.payload;
    },
  },
  extraReducers: {
    [createOtp.fulfilled]: (state, action) => {
      if (!action.payload) {
        return;
      }
      state.sessionId = action.payload.sessionId;
      state.otpDetails.numOfAttempts = ++state.otpDetails.numOfAttempts;
    },
    [getDetails.fulfilled]: (state, action) => {
      if (!action.payload) {
        return;
      }
      state.iecResponse = action.payload;
    },
    [getOderPrice.fulfilled]: (state, action) => {
      if (!action.payload || !action.payload.successCatalogResult.isSuccess) {
        return;
      }
      state.summaryDetails.orderId = action.payload.successCatalogResult.orderId;
    },
    [getEMVStep1.fulfilled]: (state, action) => {
      if (!action.payload) {
        return;
      }
      state.paymentInfo.iframeUrl = action.payload.paymentCGUrl;
    },
    [getEMVStep2.fulfilled]: (state, action) => {
      if (action.payload.returnCode == '00') {
        if (action.payload.authNumber) {
          state.paymentInfo.confirmationNumber = action.payload.authNumber;
          state.paymentInfo.CardDueYear = action.payload.cardYear;
          state.paymentInfo.CardDueMonth = action.payload.cardMonth;
          state.paymentInfo.id = action.payload.id;
          state.paymentInfo.CGData = action.payload;
          state.paymentInfo.CCToken = action.payload.ccToken;
          state.paymentInfo.CCType = action.payload.ccType;
          state.paymentInfo.Credit4Digits = action.payload.credit4Digits;
          state.paymentInfo.paymentCount = action.payload.totalPayments;
          if (action.payload.cvv) state.paymentInfo.CCvv = action.payload.cvv;
        }
      }
    },
    [createWorkOrder.fulfilled]: (state, action) => {
      if (!action.payload) {
        state.workOrderSuccess = false;
        return;
      }
      if(action.payload.isSuccess){
        state.workOrderSuccess = true;
      }
      else{
        state.workOrderSuccess = false;
      }
     },
    [createEnergySignatureFile.fulfilled]: (state, action) => {
      if (!action.payload) {
        return;
      }
      state.signatureInfo = action.payload;
    },
    [getEnergySignatureFileStatus.fulfilled]: (state, action) => {
      if (!action.payload) {
        return;
      }
      state.signatureInfo.isSigned = action.payload?.isSigned;
    }
  },
});

export const {
  resetBlock,
  initEnergySale,
  goToPage,
  reportAnalytics,
  setErrorPage,
  setErrorText,
  setOtpForm,
  setOtpCode,
  setOtpErrorMsg,
  setIsSubmit,
  setOtpStep,
  setPersonalInfo,
  setUserAddress,
  setSelectedPackage,
  setEmail,
  resetCgIframeUrl,
  setIsReceivingAd,
  setConfirmTerms,
  setConfirmTermsError,
  setLeadPage,
  setServiceMessageType,
  setIsDisplayPopupForHelp,
  setIsWhatsAppActive,
  reportDWH,
  saveToHistory,
  setDisplayAlternativePackage,
  setIecResponse,
  setIframeUrl,
} = energySaleBlockSlice.actions;

export default energySaleBlockSlice.reducer;

function getPageSettings(startPosition, page){
  const pages = energySalePages[startPosition];
  let pageObj = pages?.find((x) => x.page == page);
  let pageSetting  = {};

  if (pageObj) {
    pageSetting.step = pageObj.step;
    pageSetting.displayPackageBanner = pageObj.displayPackageBanner ?? false;
    pageSetting.displayBigBanner =  pageObj.displayBigBanner ?? false;
  }

  return pageSetting;
}

function getSelectedPackage(salePackage){
  let packageData = {};
  if(salePackage && Object.keys(salePackage).length > 0){
    const title = salePackage.title.trim().replace(/<[^>]+>/g, '');
    packageData.offerId = salePackage.offerID;
    packageData.orderType = salePackage.orderType;
    packageData.isSmartMeterPackage = !!salePackage.isSmartMeterPackage;
    packageData.isSuitableForAllMeterTypesPackage = !!salePackage.isSuitableForAllMeterTypesPackage;
    packageData.title = title;
    packageData.priceText = (salePackage.textBeforePrice ?? '') + ' ' + (salePackage.price ?? '') + ' ' + (salePackage.priceText ?? '');
    packageData.details = [
      {text: salePackage.headerOneTitle, icon: salePackage.headerFirstFeatureIcon },
      {text: salePackage.headerTwoTitle, icon: salePackage.headerSecondFeatureIcon },
      {text: salePackage.headerThirdTitle, icon: salePackage.headerThirdFeatureIcon },
      {text: salePackage.headerFourthTitle, icon: salePackage.headerFourthFeatureIcon }
    ]
  }
  return packageData;
}

